module.exports = __webpack_public_path__ + "static/Ferry_smallBanner-dc3854ee1143c1db8974ff4f6912bf71.png";